import SubCategoriesList from "../../components/categories/SubCategoriesList"

export const CatalogsPage = () => {

    return (
        <SubCategoriesList></SubCategoriesList>
    )
}